import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import { Edit } from "@mui/icons-material";
import axios from "../../../lib/axios";
import TextField from "@mui/material/TextField";
import moment from "moment/moment";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  zIndex: 10,
};

export default function AdminUpdateCost(item) {
  const [open, setOpen] = useState(false);
  const Token = localStorage.getItem("accessToken");
  const [disabled, setDisabled] = useState(true);
  const [id] = useState(item.id);
  const [costDate, setCostDate] = useState("");
  const [description, setDescription] = useState("");
  const [inComingAmount, setInComingAmount] = useState();
  const [outComingAmount, setOutComingAmount] = useState();
  const { width } = useWindowDimensions();

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  console.log(item.data);

  const updateStudent = (e) => {
    e.preventDefault();
    const formData = {
      incoming_amount: inComingAmount,
      out_coming_amount: outComingAmount,
      cost_date: moment(costDate)
        .format("MM/DD/YYYY"),
      id: item.data.id,
      description,
    };

    axios
      .put("/payment/expenses", formData, config)
      .then((response) => {
        console.log(response.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });

    console.log(formData);
  };

  useEffect(() => {
    if (inComingAmount && outComingAmount && costDate && id && description) {
      setDisabled(false);
    }
  }, [disabled]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <Edit />
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box component="form" sx={style} noValidate autoComplete="off">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                rowGap: "20px",
                columnGap: "20px",
              }}
            >
              <TextField
                required
                label="Kirim summasi"
                style={ width < 500 ? { width: "100%" } : { width: "200px" }}
                type="text"
                value={inComingAmount}
                onChange={(e) => setInComingAmount(Number(e.target.value))}
              />
              <TextField
                required
                label="Chiqim summasi"
                style={ width < 500 ? { width: "100%" } : { width: "200px" }}
                type="text"
                value={outComingAmount}
                onChange={(e) => setOutComingAmount(Number(e.target.value))}
              />
              <TextField
                required
                // label="Harajat vaqti"
                style={ width < 500 ? { width: "100%" } : { width: "200px" }}
                type="date"
                value={costDate}
                onChange={(e) => setCostDate(e.target.value)}
              />
              <TextField
                required
                label="Tavsif"
                style={ width < 500 ? { width: "100%" } : { width: "200px" }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Button variant="contained" style={{ width: "100%" }} onClick={updateStudent}>
                Update Cost
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
